import React, { Component } from 'react';
import {withRouter} from 'react-router'
import Minimalistic from 'react-sortable-tree-theme-minimal';
import SortableTree, { toggleExpandedForAll, getFlatDataFromTree, getTreeFromFlatData, map, walk } from 'react-sortable-tree';
import Dialogue from '../../../../Templates/Dialogue'
class TableOfContents extends Component {
    constructor(props) {
        super()
        this.state = {
            displayingAttachmentsList: false,
            displayingInfoItemsList: false,
            treeData: props.steps,
            flatData: this.flattenTree(props.steps),
        }
    }
    componentDidMount = () => {
        this.expand(true)
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.currentStep !== prevProps.currentStep) {
            this.focusScroll()
        }
    }

    expand(expanded) {
        this.setState({
            treeData: toggleExpandedForAll({
                treeData: this.state.treeData,
                expanded,
            }),
        });
    }

    flattenTree = (steps) => {
        let tree = getFlatDataFromTree({
            treeData: steps,
            getNodeKey: (({ node }) => node._id),
            ignoreCollapsed: false,
        }).map(node => {
            node.parentNode = node.path[node.path.length - 2]
            return node
        });
        return tree
    }

    focusScroll = () => {
        if (this.props.currentStep) {
            let step = document.getElementsByClassName(`rstcustom__row step-${this.props.currentStep._id} selected-container`)[0]
            if (step) {
                step.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }
    } 

    moveStep = (value) => {
        let currentStepIndex = this.props.currentStepIndex
        let nextIndex = currentStepIndex + value
        if (nextIndex < 0 || nextIndex > this.state.flatData.length - 1) return
        let nextNode
        let flatData = this.state.flatData
        map({
            treeData: flatData,
            getNodeKey: (({ node }) => node._id),
            callback: (node) => {
                let step = this.state.flatData[currentStepIndex]
                let stepId = step.node._id
                if (node.treeIndex === nextIndex) {
                    nextNode = node.node.node
                }
                if (stepId === node.node.parentNode) {
                    step.expanded = true
                    step.node.expanded = true
                    node.node.expanded = true
                    flatData[currentStepIndex] = step
                    this.expand(true)
                }
                return node
            }
        })

        let steps = this.rebuildTree(flatData)

        this.setState({
            flatData,
            steps,
        }, this.props.updateCurrentStepIndex(nextIndex, nextNode));
    }

    promptExit = () => {
        
    }

    selectStep = (step, path) => {
        let index

        walk({
            treeData: this.state.flatData,
            getNodeKey: (({ node }) => node._id),
            callback: ({ node }) => {
                //finding a step by click/selection
                if (step && node.node._id === step._id) {
                    index = node.treeIndex
                }
            }
        })

        this.setState({ path }, () => this.props.updateCurrentStepIndex(index, step))
    }

    rebuildTree = (flatData) => {
        let tree = getTreeFromFlatData({
            flatData,
            ignoreCollapsed: false,
            getNodeKey: (node => node._id),
            getParentKey: (node) => {
                return node.parentNode ? node.parentNode : "0"
            },
        })
        return tree
    }

    renderArrowClassNames = (stepIncrement) => {
        let totalSteps = this.state.flatData
        let currentStepIndex = this.props.currentStepIndex
        let maxIndex = totalSteps - 1
        let minIndex = 0

        if (totalSteps === 0) {
            return "no-steps-navigation-arrow"
        } else if (currentStepIndex + stepIncrement > maxIndex || currentStepIndex + stepIncrement < minIndex) {
            return "no-steps-navigation-arrow"
        } else {
            return "steps-navigation-arrow"
        }
    }

    render() {
        const { treeData } = this.state;

        return <div id="table-of-contents-container" style={{height: '100%'}} className="overflow">
            {this.state.promptingExit ? <Dialogue
                alert={"This is the end of the work instruction, would you like to exit?"}
                confirmAction={() => this.props.history.goBack()} 
                cancel={() => this.setState({promptingExit: false})}
                /> : null}
                    {/* <i id="minimize-chevron" className="fas fa-chevron-right"></i> */}
                    <h5 className="underline">TABLE OF CONTENTS</h5>
                    <ul id="wi-preview-steps-list" className="overflow" 
                        style={this.state.displayingAttachmentsList || this.state.displayingInfoItemsList ? {height: "0"} : {}} >
                        <SortableTree
                            treeData={treeData}
                            onChange={treeData => this.setState({ treeData })}
                            canDrag={() => false}
                            canDrop={ () => false}
                            scaffoldBlockPxWidth={22}
                            generateNodeProps={({ node, path }) => ({
                                onClick: () => this.selectStep(node, path),
                                className: this.props.currentStep._id === node._id ? `step-${this.props.currentStep._id} selected-container` : `step-${this.props.currentStep._id}`,
                            })}
                            onVisibilityToggle={({node, path}) => {
                                this.selectStep(node, path)
                            }}
                            getNodeKey={this.getNodeKey}
                            theme={Minimalistic}
                            style={{ width: '32em' }}
                            rowHeight={36}
                        />
                    </ul>
                    <div id="preview-table-actions-container" className="flex">
                        <h3 id="preview-step-title-display" className="flex-centered max-width ellipsis">{this.props.currentStep.title}</h3>
                    </div>
                    <div id="steps-navigation-arrows-container" className="max-width flex-apart">
                        <div id="steps-navigation-arrow-container" className="flex-centered" onClick={() => this.moveStep(-1)}>
                            <i id={this.renderArrowClassNames(-1)} className="fas fa-chevron-left" />
                       </div>
                        {this.props.currentStepIndex !== this.state.flatData.length - 1 ? 
                            <div id="steps-navigation-arrow-container" className="flex-centered" onClick={() => this.moveStep(1)}>
                                <i id={this.renderArrowClassNames(1)} className="fas fa-chevron-right"/>
                            </div> 
                                : 
                            <div id="steps-navigation-arrow-container" className="flex-centered" onClick={() => this.setState({promptingExit: true})}>
                                <i class="far fa-window-close"></i>
                            </div>}
                    </div>
        </div>
    }
}

export default withRouter(TableOfContents)